import { type DatePickerProps } from ".";

export const datePickerGroupClassname = (
	isDisabled: boolean,
	size: DatePickerProps["size"],
	type: "standalone" | "embedded"
) => [
	"flex space-x-2 items-stretch group",
	"[&>*>svg]:fill-icon-default",
	{
		// Background
		"bg-primary": type === "standalone",

		// Border styling to match Input component
		"border": type === "standalone",
		"border-palette-gray-7": type === "standalone" && !isDisabled,
		"hover:border-palette-gray-8": type === "standalone" && !isDisabled,
		"focus-within:border-palette-brand-8": type === "standalone" && !isDisabled,
		"focus-within:outline": type === "standalone" && !isDisabled,
		"focus-within:outline-2": type === "standalone" && !isDisabled,
		"focus-within:-outline-offset-2": type === "standalone" && !isDisabled,
		"focus-within:outline-palette-brand-9": type === "standalone" && !isDisabled,

		// Disabled state
		"opacity-60": isDisabled,
		"cursor-not-allowed": isDisabled,

		"rounded": size === "sm",
		"rounded-md": size === "md",
		"rounded-lg": size === "lg",

		"h-7": size === "sm",
		"h-8": size === "md",
		"h-10": size === "lg",

		"pl-2": size === "sm" && type !== "embedded",
		"pl-3": (size === "md" || size === "lg") && type !== "embedded",

		"text-xs": size === "sm",
		"text-sm": size === "md" || size === "lg",
	},
];
